export default "__VITE_ASSET__CswOMtNz__"